// Class: haxe.ds.IntMap

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function haxe_IMap() {return require("./../../haxe/IMap");}
function HxOverrides() {return require("./../../HxOverrides");}
function haxe_iterators_MapKeyValueIterator() {return require("./../../haxe/iterators/MapKeyValueIterator");}
function StringBuf() {return require("./../../StringBuf");}
function Std() {return require("./../../Std");}

// Constructor

var IntMap = function() {
	this.h = { };
}

// Meta

IntMap.__name__ = "haxe.ds.IntMap";
IntMap.__isInterface__ = false;
IntMap.__interfaces__ = [(haxe_IMap().default)];
IntMap.prototype = {
	set: function(key,value) {
		this.h[key] = value;
	},
	get: function(key) {
		return this.h[key];
	},
	exists: function(key) {
		return this.h.hasOwnProperty(key);
	},
	remove: function(key) {
		if(!this.h.hasOwnProperty(key)) {
			return false;
		}
		delete(this.h[key]);
		return true;
	},
	keys: function() {
		var a = [];
		for( var key in this.h ) (this.h.hasOwnProperty(key) ? a.push(key | 0) : null);
		return (HxOverrides().default).iter(a);
	},
	iterator: function() {
		return { ref : this.h, it : this.keys(), hasNext : function() {
			return this.it.hasNext();
		}, next : function() {
			var i = this.it.next();
			return this.ref[i];
		}};
	},
	keyValueIterator: function() {
		return new (haxe_iterators_MapKeyValueIterator().default)(this);
	},
	copy: function() {
		var copied = new IntMap();
		var key = this.keys();
		while(key.hasNext()) {
			var key1 = key.next();
			copied.set(key1,this.get(key1));
		}
		return copied;
	},
	toString: function() {
		var s = new (StringBuf().default)();
		s.add("{");
		var it = this.keys();
		var i = it;
		while(i.hasNext()) {
			var i1 = i.next();
			s.add(i1);
			s.add(" => ");
			s.add((Std().default).string(this.get(i1)));
			if(it.hasNext()) {
				s.add(", ");
			}
		}
		s.add("}");
		return s.toString();
	},
	clear: function() {
		this.h = { };
	}
};
IntMap.prototype.__class__ = IntMap.prototype.constructor = $hxClasses["haxe.ds.IntMap"] = IntMap;

// Init



// Statics




// Export

exports.default = IntMap;